import { Injectable } from '@angular/core';
import { Constants } from '../../shared/Constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class BuyOrderService {

  constructor(private http: HttpClient) { }

  getAllBuyOrderHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND + '/buy-order-header', { headers: headers });
  }
  getBuyOrderHeader(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.get(Constants.URL_BACKEND + '/buy-order-header/' + id, { headers: headers });
  }

  getBuyOrderHeaderProveedor( proveedor, fechainicio, fechafinal) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/buy-order-headerfiltro', { params: { proveedor: proveedor, fechainicio: fechainicio, fechafinal: fechafinal }, headers: headers });
  }

  createBuyOrderHeader(insertData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/buy-order-header', { data: insertData }, { headers: headers });
  }
  updateBuyOrderHeader(updateData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.put(Constants.URL_BACKEND + '/buy-order-header/' + updateData.id, { data: updateData }, { headers: headers });
  }
  deleteBuyOrderHeader(id) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.delete(Constants.URL_BACKEND + '/buy-order-header/' + id, { headers: headers });
  }
  InsertAllDetails(array, buyOrderHeaderId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.put(Constants.URL_BACKEND + '/buy-order-detail/all/' + buyOrderHeaderId, { data: array }, { headers: headers });
  }
  getBuyOrderDetails(headerId) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/buy-order-detail/buy-order-header/' + headerId, { headers: headers });
  }
  getOneDetail(id) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/buy-order-detail/' + id, { headers: headers });
  }
  insertBatch(insertData) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/buy-order-detail/batch', { data: insertData }, { headers: headers });
  }
  sendMail(data,email){
    console.log("data",data);
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

    return this.http.post(Constants.URL_BACKEND + '/sendMailBO', { data: data, email: email }, { headers: headers });

  }

  downloadBuyOrderList(filters) {
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(localStorage.getItem('jwt'))
    );

    const optionArgs = {
      headers: headers,
      responseType: 'blob' as 'json'
    }

    return this.http.post(Constants.URL_BACKEND + '/buy-order-header-list/export', filters, optionArgs);
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/buy-order.service.ts